const userActivities = [
  {
    id: 0,
    position: 0,
    title: "Activité" // (not used anymore) Marques localisation => i18n
  },
  {
    id: 1,
    position: 1,
    title: "Architecte"
  },
  {
    id: 2,
    position: 2,
    title: "Architecte d’intérieur"
  },
  {
    id: 3,
    position: 3,
    title: "Designer"
  },
  {
    id: 4,
    position: 4,
    title: "Bureau d’étude"
  },
  {
    id: 5,
    position: 5,
    title: "Entreprise générale"
  },
  {
    id: 6,
    position: 6,
    title: "Promoteur"
  },
  {
    id: 7,
    position: 7,
    title: "Menuisier / Agenceur"
  },
  {
    id: 8,
    position: 8,
    title: "Economiste"
  },
  {
    id: 9,
    position: 9,
    title: "Acousticien"
  },
  {
    id: 10,
    position: 10,
    title: "Industriel"
  },
  {
    id: 11,
    position: 11,
    title: "Maitre d’Ouvrage"
  },
  {
    id: 12,
    position: 12,
    title: "Autre"
  }
];

export default userActivities;



// WEBPACK FOOTER //
// ./src/constants/userActivities.js